export default __webpack_public_path__ + "scripts/resource/9429ce1f5d75cb40cfa93bba0994649e.svg";